module.exports = __webpack_public_path__ + "media/images/iconDelete__errorRed-f66e6fe9bc2b0f2e2f0819ff2db938bb.png";